module.exports = __webpack_public_path__ + "img/ver1.57580d08.jpg";